import { HUBSPOT_PAGES, SUBSCRIPTION } from '@App/routes';
import HubspotLink from '@App/components/navigation/HubspotLink';
import useAuth from '@App/common/hooks/useAuth';

/**
 * Standing invitation to subscribe, shown on the pages where the catalogue is browsed: the music
 * library, a playlist, a project and the sound effects page.
 *
 * Shown to anonymous visitors as well as to signed-in users without a subscription. Browsing is open
 * to anyone, so anyone can reach the point where a download is refused — and the visitor who has not
 * signed up yet is precisely the one this block is written for. `useAuth` reports an anonymous
 * visitor as unauthenticated with empty permissions, so no server-side permission is needed for it:
 * the absence of an account is itself the reason to show the block.
 */
export default function IncentiveBanner() {
  const { authenticated, permissions } = useAuth();

  if (authenticated && !permissions.displaySubscriptionBanner) {
    return null;
  }

  return (
    <div className="subscription-cta">
      <div className="subscription-cta__body">
        <h3 className="subscription-cta__title">
          La librairie musicale n°1 en France.<br />
          360 000 musiques. 200 000 SFX.
        </h3>
        <p className="subscription-cta__lead">
          Créez sans limite. La référence des créatifs. Au meilleur prix.
        </p>

        <div className="subscription-cta__actions">
          {/* The internal route, not the absolute app.miooz.com URL of the copy: same page, but it
              stays a client-side navigation and keeps working outside production. */}
          <a href={SUBSCRIPTION.getUrl()} className="btn btn--primary" draggable="false">
            Essayer gratuitement
          </a>
          <HubspotLink route={HUBSPOT_PAGES.DEMO} className="btn btn--light">
            Demander une démo
          </HubspotLink>
        </div>
      </div>
    </div>
  );
}
